<template>
    <div class="kgk-certificate-list">
        <div v-if="certificates.length === 0" style="margin-top:8px;">
            <i>{{ emptyText }}</i>
        </div>
        <template v-else>
            <ul style="list-style:none;padding:0;margin:0;">
                <li v-for="(certificate, index) in visibleCertificates" :key="index" style="margin-bottom:8px;text-align:left;">
                    <div class="kgk-input-group" style="max-width:300px;margin-left:auto;margin-right:auto;">
                        <input type="text" disabled :value="certificate.template_name" style="padding-right: 48px">
                        <div class="kgk-input-group-append">
                            <a v-if="certificate.download_url" :href="certificate.download_url" target="_blank" v-tooltip="'Urkunde herunterladen'"><i class="fas fa-download fa-fw"></i></a>
                        </div>
                    </div>
                    <div style="font-size:12px;color:#888;max-width:300px;margin-left:auto;margin-right:auto;">
                        {{ formatDate(certificate.sent_at) }}
                    </div>
                </li>
            </ul>
            <div v-if="certificates.length > 1" style="margin-top:4px;">
                <a href="#" @click.prevent="expanded = !expanded" style="font-size:12px;">
                    {{ expanded ? 'Weniger anzeigen' : 'Weitere anzeigen (' + (certificates.length - 1) + ')' }}
                </a>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'CertificateList',
    props: {
        certificates: {
            type: Array,
            default: () => [],
        },
        emptyText: {
            type: String,
            default: 'Noch keine Urkunden erhalten',
        },
    },
    data() {
        return {
            // On-demand disclosure -- only the latest certificate shows by
            // default, the rest are revealed via the toggle below.
            expanded: false,
        }
    },
    computed: {
        visibleCertificates() {
            return this.expanded ? this.certificates : this.certificates.slice(0, 1);
        },
    },
    methods: {
        formatDate(dateString) {
            if(!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('de-DE');
        },
    },
}
</script>
